import { SelectCreatableInput } from '@core/components/Select';
import imovelApi from 'app/services/api/imovelApi';
import React from 'react';

const carregarImoveis = async (query = '', page = 0) => {
  const response = await imovelApi.get({
    page,
    size: 100,
    sort: 'nome,asc',
    q: typeof query === 'string' && query.length ? query : '',
  });

  if (response?.data && response.data.content) {
    return response.data.content;
  }
  return [];
};

const SelectImovelCreatable = ({
  imovel,
  handleChange,
  handleBlur,
  touched,
  error,
  label = 'Imóvel',
  id = 'imovel',
  idObject = 'imovel',
  onCadastrarImovel,
  autoFocus,
  required,
  disabled,
  tamanhoMinimo = 3,
  maxLength = 100,
}) => {
  return (
    <SelectCreatableInput
      required={required}
      onBlur={handleBlur}
      touched={touched}
      error={error}
      label={label}
      id={id}
      value={{ ...imovel }}
      autoFocus={autoFocus}
      disabled={disabled}
      onChange={(value) => {
        handleChange({
          target: {
            id: idObject,
            value: {
              id: value?.id,
              nome: value?.nome,
            },
          },
        });
      }}
      getOptionKey={(option) => {
        if (option) {
          return option?.id;
        }
        return '';
      }}
      getOptionLabel={(option) => {
        if (option) {
          return option?.nome;
        }
        return '';
      }}
      onClearInput={() => {
        handleChange({ target: { id: idObject, value: undefined } });
      }}
      fetchData={carregarImoveis}
      onCreateOption={onCadastrarImovel}
      fetchOnFocus
      tamanhoMinimo={tamanhoMinimo}
      maxLength={maxLength}
    />
  );
};

export default SelectImovelCreatable;
